import { validateBr } from 'js-brasil'

export function validateVoterCertificate(voterCertificate: string): boolean {
  return true
  return validateBr.titulo(voterCertificate)
}
